



























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { InputError } from '@/models';

@Component
export default class TireLocationNoTableField extends Vue {
    @Prop() private data!: any;

    private isEditRow: boolean = this.data.item.isEdit

    private getInputError(field: string): InputError | undefined {
        const inputError = this.data.item.errors.find((e: any) => e.field === field);   
        return inputError ? inputError : undefined;
    }

    private onInputChange(field: string) {
        this.$emit('onInputChange', field, this.data.item.id);
    }

    private getMsgErrorLocationNo(dataTabe: any): InputError | [] {
        const erros = dataTabe.errors.find(
        (e: any) => e.field === 'rackLocation' && e.message.length > 0 
                    || e.field === 'columnLocation' && e.message.length > 0
                    || e.field === 'rowLocation' && e.message.length > 0
        );
        return erros || [];
    }

    private isEdit() {
        this.isEditRow = true;
        this.$emit('isEdit', this.data.item.id);
    }

    private updateLocationNo() {
        this.isEditRow = false;
        this.$emit('updateLocationNo', this.data.item);
    }
}
